import TextField from "../../../../../../shared/TextField/TextField";
import { useEffect, useState } from "react";

const LevelAndPointsRange = (props) => {
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let currentUrl = null;
    const loadImage = async () => {
      if (props.row.Id.split('-')[0] != 'temp') {
          const themeSuffix = props.theme === 'dark' ? 'oscuro' : 'claro';
          const themedUrl = await props.getImageUrl(`${props.row.Id} ${themeSuffix}`);
          const url = themedUrl || await props.getImageUrl(props.row.Id);
          currentUrl = url;
          if (!cancelled) setImageUrl(currentUrl);
        }
    };
    loadImage();
    return () => {
      cancelled = true;
      if (currentUrl) URL.revokeObjectURL(currentUrl);
    };
  }, [props.row.Id, props.theme, props.updateImage]);

  return (
    <>
      <td className={`level-name-col border border-gray-300 px-4 py-4 font-semibold text-gray-800 bg-gray-100`}>
        <TextField
          isEditor={props.isEditor}
          id={props.row.Id}
          field="Insignia"
          value={props.row.Insignia}
          setData={props.setLevels}
          className={'text-gray-800'}
        />
        {props.isEditor && props.row.Id.split('-')[0] != 'temp' && (
          <>
            <label className="block w-full cursor-pointer rounded-md px-4 py-3 text-center text-sm font-medium
            text-white transition border bg-personalized hover:bg-white hover:text-personalized hover:border-personalized"
          >
            Actualizar Insignia
            <input
              type="file"
              accept=".png"
              className="hidden"
              onChange={(e) => {props.updateImage(e, props.row.Id)}}
            />
          </label>
          </>
        )}
        {imageUrl && props.row.Id.split('-')[0] != 'temp' && (
          <img src={imageUrl} alt="Insignia" className="mt-2 mx-auto" style={{transform: 'scale(1.6)'}}/>
        )}
      </td>
      <td className={`border border-gray-300 px-4 py-4 ${props.isEditor ? 'bg-gray-50' : 'bg-white'}`}>
        <div className={props.isEditor ? 'grid grid-cols-[1fr_auto] items-center gap-2' : 'inline'}>
          <TextField
            type="number"
            isEditor={props.isEditor}
            id={props.row.Id}
            field="Minimum"
            value={props.row.Minimum}
            setData={props.setLevels}
            className={props.inputClassName}
          />
          <span className="text-sm text-gray-600"> a </span>            
          <TextField
            type="number"
            isEditor={props.isEditor}
            id={props.row.Id}
            field="Maximum"
            value={props.row.Maximum}
            setData={props.setLevels}
            className={props.inputClassName}
          />
          <span className="text-sm text-gray-600"> puntos</span>
        </div>
      </td>
    </>
  )
};

export default LevelAndPointsRange;
